.placeholder {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(54, 123, 255, 0.12);
  color: var(--color-secondary);
  font-size: 1.6rem;
  padding: 0 2rem;

  span {
    display: inline-block;
    margin-top: 0.8rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: rgba(255, 255, 255, 0.4);
    text-align: center;
  }

  &:hover {
    cursor: pointer;
  }
}

.icon {
  height: 3.2rem;
  width: 3.2rem;
  border-radius: var(--border-radius-medium);
  cursor: pointer;
  display: flex;
  font-size: 2.4rem;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  background-color: var(--color-secondary);
  color: #273046;
  margin-bottom: 1.2rem;
}

.upload-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: var(--border-radius-medium);
  border: 1.5px dashed var(--color-secondary);
}
